import { useCallback, useEffect, useMemo } from "react";

import { useScriptLoader } from "components/ScriptLoader";

export function useChargebeeScriptLoader(site, publishableKey) {
  const shouldLoad = useMemo(() => {
    return site && publishableKey;
  }, [site, publishableKey]);

  const [loadingScript, errorScript] = useScriptLoader({
    src: shouldLoad ? "https://js.chargebee.com/v2/chargebee.js" : null,
    checkForExisting: true,
    onLoad: useCallback(() => {
      try {
        window.Chargebee.getInstance();
      } catch {
        window.Chargebee.init({ site, publishableKey });
      }
    }, [site, publishableKey]),
  });

  useEffect(() => {
    if (errorScript) console.error("useChargebee", errorScript);
  }, [errorScript]);

  return {
    loading: !errorScript && loadingScript,
    error: errorScript,
    shouldLoad: shouldLoad,
  };
}

export default useChargebeeScriptLoader;
